import { ErrorBag } from 'vee-validate'

export const isMobile = () => {
  const ua = navigator.userAgent
  const regexp = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/
  return regexp.test(ua) && !isTablet()
}

export const isTablet = () => {
  const ua = navigator.userAgent
  const regexp = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i
  return regexp.test(ua)
}

export const isDesktop = () => {
  return !isMobile() && !isTablet()
}

export const isIE = () => {
  return window.navigator.userAgent.toLowerCase().includes('msie')
}

export const hexColorToDec = (color: string) => {
  const rExp = /[^a-z0-9]/gi
  const hex = color.replace(rExp, '')

  return parseInt(hex, 16)
}

export const getCameraPermissions = async (): Promise<string> => {
  try {
    const permissions = await navigator.permissions.query(<PermissionDescriptor><unknown>{ name: 'camera' })
    return permissions.state
  } catch (e) {
    return 'An error occurred while was trying to get camera permissions'
  }
}

export const b64toBlob = (b64Data: string, contentType: string, sliceSize?: number) => {
  contentType = contentType || ''
  sliceSize = sliceSize || 512

  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)

    byteArrays.push(byteArray)
  }

  return new Blob(byteArrays, { type: contentType }) as File
}

export const detectWebcam = (): Promise<boolean> => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const md = navigator.mediaDevices
    if (!md || !md.enumerateDevices) {
      return reject(new Error('Error accessing media navigator.mediaDevices.enumerateDevices'))
    }

    const devices = await md.enumerateDevices()
    const isCameraAvailable = devices.some(device => device.kind === 'videoinput')

    return isCameraAvailable ? resolve(true) : reject(new Error('Video devices were not found'))
  })
}

export const omitNonDigitPipe = (raw: string) => {
  return raw.replace(/\D+/g, '')
}
